import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface TenantState {
  slug_name: string;
  keyCloakOrganizationUUID: string;
  keyCloakClientUUID: string;
  logo: string;
}

const initialState: TenantState = {
  slug_name: "",
  keyCloakOrganizationUUID: "",
  keyCloakClientUUID: "",
  logo: "",
};

const tenantSlice = createSlice({
  name: "tenant",
  initialState,
  reducers: {
    setTenantInfo: (state, action: PayloadAction<TenantState>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setTenantInfo } = tenantSlice.actions;
export default tenantSlice.reducer;
